@import "../../../theme/global";

.node-titles:not(:empty) {
  padding: 0;
  min-height: auto;
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}

.node-titles:empty {
  display: none !important;
  padding: 0;
  min-height: 0;
}
h2, h3 {
  padding: 0;
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
  line-height: 1.3;
}
h3 {
  color: $text-color-step-400;
  font-weight: 400;
  font-size: 0.875rem;
}

h2:empty, h3:empty {
  display: none !important;
}

h2:has(lar-translate:empty), h3:has(lar-translate:empty) {
  display: none !important;
}

lar-translate:empty {
  display: none !important;
}
